import React, { Component } from 'react';

import { Form } from 'react-bootstrap';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class CommonSelect extends Component{

    render = () => {

        let props = this.props;

        let { type, id, label, value, validator, error} = props?.input;

        let { element, option, instanceOptionName= null, callback , disabled = false, hr = false, floatingLabel = true, size="md" } = props;

        let { source, section, item, data } = option

        let lists = [];

        if( source === 'options' ){
            lists = options[section][item];
        }else if( source === 'db' ){
            lists = {defaulted: true, options: option.data};
        }

        lists = {
            ...lists,
            options: lists?.options?.filter(option => option.id !== '') || []
        };
        
        return (
            <>
                {element === 'Inputs' && label !== '' && floatingLabel === true && (
                    <div className="mb-0">
                        <Form.Label className={size === 'sm' ? 'label-size-sm' : ''}>
                            {label}{' '}
                            {validator.required && (
                                <i
                                className="fa-classic fa-light fa-asterisk fa-fw"
                                style={{
                                    fontSize: '0.5rem',
                                    verticalAlign: 'text-top'
                                }}
                                />
                            )}
                        </Form.Label>
                    </div>
                )}
                <Form.Select 
                    aria-label={label}
                    id={id}
                    name={`${element}_${id}`}
                    value={value !== undefined ? value : ''}
                    className={`form-control ${error?.status === true ? "is-invalid" : error?.status === false ? "is-valid" : ""}`} 
                    onChange={(e) => callback(e , element)}
                    disabled={disabled}
                    size={size}
                >
                    {lists.defaulted && (
                        <option value = ''>กรุณาระบุ</option>
                    )}
                    {lists.options.map(option => (
                        <option 
                            key={option.id} 
                            value={source === 'options' ? option.value : option.id}
                        >
                            {
                                source === 'options'
                                    ? option.label
                                    : source === 'db'
                                    ? (option[instanceOptionName] ?? option.name)
                                    : null
                            }
                        </option>
                    ))}
                </Form.Select>
                
                {(element === 'Inputs' && error?.status) && (
                    <Form.Control.Feedback type="invalid" className="mt-2 ms-2" style={{fontSize: '0.75rem'}}>
                        <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                        {error?.msg}
                    </Form.Control.Feedback>
                )}

                {hr && (<hr className="hr-custom" />)}
            </>
        )
    }
}

export default CommonSelect;